import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useStaticQuery, graphql } from "gatsby";

const Home = () => {
  const data = useStaticQuery(graphql`
    {
      allFile(filter: { extension: { eq: "pdf" } }) {
        nodes {
          name
          publicURL
        }
      }
    }
  `);
  const resume = data.allFile.nodes[0].publicURL;
  return (
    <div
      id="home"
      className="w-full flex md:min-h-screen flex-col md:flex-row items-center justify-evenly  overflow-x-visible"
    >
      <div className="relative w-full md:w-1/2 my-60">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 rounded-full bg-primary opacity-30" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 ml-3 rounded-full bg-primary opacity-30" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 ml-6 rounded-full bg-primary opacity-30" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 ml-9 rounded-full bg-primary opacity-30" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 ml-12 rounded-full bg-primary opacity-30" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 ml-15 rounded-full bg-primary overflow-hidden">
          <StaticImage
            src="../images/Profile.jpg"
            alt="Profile Image"
            layout="constrained"
            placeholder="blurred"
            className="w-80 h-80 object-contain"
          />
        </div>
      </div>
      <div className="w-full md:w-1/2 flex flex-col items-center text-center md:items-start md:text-left justify-center my-20">
        <h1 className="text-base sm:text-xl text-black font-custom uppercase">
          Hi there! I'm{" "}
          <span className="block text-2xl sm:text-4xl font-medium text-primary py-5">
            Usama Tahir
          </span>
        </h1>
        <p className="text-xl font-custom font-normal text-black max-w-xl mb-5">
          A <span className="text-primary font-semibold">Javascript</span>{" "}
          developer with a focus on{" "}
          <span className="text-primary font-semibold">front-end</span>{" "}
          libraries & frameworks such as{" "}
          <span className="text-primary font-semibold">
            React, Gatsby & Next.js
          </span>{" "}
          and passionate about Headless eCommerce, design system and Serverless Technologies
        </p>
        <div className="mt-5 flex flex-col sm:flex-row items-center">
          <a
            href={resume}
            download
            className="bg-primary rounded-3xl w-40 py-3 px-6 text-xl text-white font-custom text-center shadow-md hover:shadow-2xl transform transition duration-300"
          >
            Resume
          </a>
          <ul className="flex items-center list-none mt-5 sm:mt-0 sm:ml-10">
            <li className="mx-2 shadow-md hover:shadow-lg transform transition duration-300 hover:scale-105 ">
              <a
                href="https://www.linkedin.com/in/usamatahir0/"
                className="w-10 h-10 rounded-md border border-gray-100 bg-white text-center flex items-center justify-center"
              >
                <StaticImage
                  src="../images/linkedin.png"
                  alt="Profile Image"
                  layout="constrained"
                  placeholder="blurred"
                  className="w-5 h-5 object-cover"
                />
              </a>
            </li>
            <li className="mx-2 shadow-md hover:shadow-lg transform transition duration-300 hover:scale-110 ">
              <a
                href="https://www.github.com/usaamatahir/"
                className="w-10 h-10 rounded-md border border-gray-100 bg-white text-center flex items-center justify-center"
              >
                <StaticImage
                  src="../images/Github.png"
                  alt="Profile Image"
                  layout="constrained"
                  placeholder="blurred"
                  className="w-5 h-5 object-cover"
                />
              </a>
            </li>
            <li className="mx-2 shadow-md hover:shadow-lg transform transition duration-300 hover:scale-110 ">
              <a
                href="http://www.twitter.com/usamatahir0"
                className="w-10 h-10 rounded-md border border-gray-100 bg-white text-center flex items-center justify-center"
              >
                <StaticImage
                  src="../images/twitter.png"
                  alt="Profile Image"
                  layout="constrained"
                  placeholder="blurred"
                  className="w-5 h-5 object-cover"
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Home;
